module.exports = __webpack_public_path__ + "static/media/CICLO_6_PROSPERIDAD_DIGITAL_2022.a68e7843.jpg";